import React, { useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import Loading from "../../components/common/Loading/Loading";
import hecologo from "../../images/hecoanalytics_logo.svg";
import TextField from "@mui/material/TextField";

import "./login.css";

function Login() {
  const [spinner, setSpinner] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [signIn, setSignIn] = useState("Sign In");
  const [errorMessage, setErrorMessage] = useState("");
  const authenticate = useOutletContext().authenticate;
  const getUserDetails = useOutletContext().getUserDetails;
  var position = useOutletContext().position;
  const getCompanies = useOutletContext().getCompanies;
  const getRepositories = useOutletContext().getRepositories;

  const navigate = useNavigate();
  const loading = () => {
    if (spinner === true) {
      return <Loading />;
    } else {
      return <div>{signIn}</div>;
    }
  };

    //get user Attributes from Cognito
    const getAttributeValue = (attributes, attributeName) => {
      const attribute = attributes.find(
        (attribute) => attribute.Name === attributeName
      );
      return attribute ? attribute.Value : null;
    };

  let style;
  if (!error) {
    style = {
      "& label.Mui-focused": {
        borderBottomcolor: "var(--orange)",
        color: "var(--orange)",
        fontFamily: "'Comic Sans', sans-serif",
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: "var(--orange)",
        fontFamily: "'Open Sans', sans-serif",
      },
    };
  } else {
    style = {
      "& .MuiFormLabel-root": {
        color: "var(--error)",
        fontFamily: "'Open Sans', sans-serif",
      },
      "& label.MuiFormLabel-root.Mui-focused": {
        color: "var(--orange)",
        fontFamily: "'Open Sans', sans-serif",
      },

      "& .MuiInput-underline:after": {
        borderBottomColor: "var(--orange)",
        color: "black",
        fontFamily: "'Open Sans', sans-serif",
      },
      "& .MuiInput-underline:before": {
        borderBottomColor: "var(--error)",
        color: "black",
        fontFamily: "'Open Sans', sans-serif",
      },
    };
  }

  const onSubmit = (event) => {
    localStorage.clear(); //clear previous data in localStorage to avoid existing data from previous sessions
    setError(false);
    setErrorMessage("");
    setSignIn(false);
    setSpinner(true);
    setEmail(email.replace(/\s/g, ""));
    event.preventDefault();
    authenticate(email, password)
      .then(() => {
        getUserDetails().then((details) => {
          localStorage.setItem("s3Link", "");
          localStorage.setItem("email", getAttributeValue(details.UserAttributes, "email"));
          position = getAttributeValue(details.UserAttributes, "custom:position");
          localStorage.setItem("position", position);
          localStorage.setItem("selectedSnapshot", "");
          if (position === "3") {
            localStorage.setItem("startSettings", "Company");
            getCompanies().then((x) => {
              navigate("/snapshots");
              setSpinner(false);
            });
          } else {
            localStorage.setItem("email", getAttributeValue(details.UserAttributes, "email"));
            localStorage.setItem("company", getAttributeValue(details.UserAttributes, "custom:company"));
            localStorage.setItem("repoName", "");
            localStorage.setItem("s3Link", "");
            localStorage.setItem("startSettings", "Repository");
            getRepositories().then((x) => {
              navigate("/snapshots");
              setSpinner(false);
            });
          }
        });
      })
      .catch((error) => {
        setError(true);
        setErrorMessage("Incorrect email or password.")
        setSpinner(false);
        setSignIn("Sign In");
      });
  };

  return (
    <div className="login-container">
      <div className="login-header">
        <img src={hecologo} alt="jsx-a11y/alt-text" />
      </div>
      <div className="main">
        <div className="signInBox">
          <div className="Title">Login to HecoRep</div>
          <TextField
            id="standard-basic"
            label="Email"
            variant="standard"
            size="50px"
            value={email}
            sx={style}
            onChange={(event) =>
              setEmail(event.target.value.replace(/\s/g, ""))
            }
          />
          <TextField
            id="standard-basic-1"
            label="Password"
            variant="standard"
            type="password"
            value={password}
            sx={style}
            onChange={(event) => setPassword(event.target.value)}
          />
          {error && (
              <div className="error-login">{errorMessage}</div>
              )}
          <button className="loginButton" type="submit" onClick={onSubmit}>
            {loading()}
          </button>
        </div>
      </div>
      <div className="footer">
        Don't have a HecoRep account? Reach out to contact@hecoanalytics.com
      </div>
    </div>
  );
}
export default Login;
